import { useChatWorkflowShared } from "@intelligems/ig-plugin/builder/workflows/execute-workflows/chat-workflow";
import { UiStreamAction } from "@intelligems/ig-types/schemas/ai/ui-stream-actions";
import { aiApiClient } from "@src/api/ai-api";
import { handleAiChatAction } from "@src/store/slices/aiChat";
import { useDispatch } from "@src/store";

export const useExperimentAnalyticsChatV2 = () => {
  const dispatch = useDispatch();

  const chatWorkflow = useChatWorkflowShared(
    aiApiClient,
    (data: UiStreamAction) => dispatch(handleAiChatAction(data))
  );
  return { chatWorkflow };
};
